import { render, staticRenderFns } from "./TheNewContactForm.vue?vue&type=template&id=fd8f4644"
import script from "./TheNewContactForm.vue?vue&type=script&lang=js"
export * from "./TheNewContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports